/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-19 14:42:59
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-29 15:12:06
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/Preview/index.tsx
 */
import React from 'react';

import {
  TopBanner,
  TopTabs, //ProductGrid
} from 'unifyxp-ecomm-components';
import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';

import styles from './style.module.less';

import { withDraggableId } from 'src/constrains/Preview/util';
import { EnumCollapseId, onCollapseOpen, getContent } from '../slice';
import { useSelector } from 'react-redux';

const _TopBanner = withDraggableId(
  TopBanner,
  EnumCollapseId.topLeaderBoardBanner,
  onCollapseOpen,
);

const _TopTabs = withDraggableId(
  TopTabs,
  EnumCollapseId.productMenu,
  onCollapseOpen,
);

// const _ProductGrid = withDraggableId(
//   ProductGrid,
//   EnumCollapseId.productMenu,
//   onCollapseOpen,
// );

const Header = ({ bannerEnabled, imgUrl, tabs, tabsEnabled }) => {
  return (
    <React.Fragment>
      {bannerEnabled && imgUrl && <_TopBanner imageUrl={imgUrl} hideTitle />}
      {tabsEnabled && <_TopTabs options={tabs} value={[0, 0]} />}
    </React.Fragment>
  );
};

function Preview(props) {
  const { wrapperClassName } = props;
  const _data: any = getContent(useSelector);
  const { productMenu, topLeaderBoardBanner } = _data;
  const { enabled: _tEnabled, linkModule } = topLeaderBoardBanner;
  const { enabled: _mEnabled, roots } = productMenu;
  const { linkImage } = linkModule || {};
  const { url } = linkImage || {};

  return (
    <PreviewContainer
      // {...(_open ? { wrapperClassName: styles.wrapperBackground } : {})}
      //containerStyle={!_open ? { background: background || '#fff' } : {}}
      wrapperClassName={wrapperClassName}
      header={
        <Header
          tabsEnabled={_mEnabled}
          tabs={roots}
          bannerEnabled={_tEnabled}
          imgUrl={url}
        />
      }
      className={styles.container}></PreviewContainer>
  );
}

export default Preview;
